module.exports = __webpack_public_path__ + "static/media/Icon_Status_Einstellen.50a9355b.svg";